"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconWithIndicator = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const defaultTheme_1 = require("../../shared/defaultTheme");
const styled_components_1 = __importDefault(require("styled-components"));
const IconWithIndicator = ({ icon, active, onClick }) => {
    return ((0, jsx_runtime_1.jsxs)(Wrapper, { active: active, onClick: onClick, children: [active && (0, jsx_runtime_1.jsx)(ActiveIndicator, {}, void 0), (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: icon, size: "sm", color: defaultTheme_1.defaultTheme.colors.whiteBase }, void 0)] }, void 0));
};
exports.IconWithIndicator = IconWithIndicator;
const Wrapper = styled_components_1.default.div `
  align-items: center;
  border-radius: 50%;
  background: ${({ active, theme }) => active ? theme.colors.greyBase : theme.colors.silverBase};
  display: inline-flex;
  height: 1.5rem;
  justify-content: center;
  position: relative;
  width: 1.5rem;
  font-size: 0.75rem;
`;
const ActiveIndicator = styled_components_1.default.div `
  position: absolute;
  top: 0;
  left: 18px;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.greenBase};
`;
//# sourceMappingURL=IconWithIndicator.js.map